import React from 'react';

import { Box, SxProps, Typography } from '@mui/material';

import { palette, spaces } from '../../../../../assets/styles/themes/tokens';
import getTextTruncationSx from '../../../../../utils/getTextTruncationSx';
import { Link } from 'found';
import useRouter from '../../../../../utils/useRouter';
import { getCardLinkProps } from '../../../../../utils/searchUtils';

const MuiCardBaseShortHeaderWithTitle: React.FC<{
  header: string;
  title: string;
  caption: string;
  itemLink: string;
  isTruncated: boolean;
  index?: number;
}> = ({ header, title, caption, itemLink, isTruncated, index }) =>  {
  const { match } = useRouter();
  const position = index !== undefined ? index + 1 : undefined; // Convert 0-indexed to 1-indexed
  
  const linkProps = getCardLinkProps(
    itemLink,
    match.location.pathname,
    position,
  );
  
  const titleTruncationSx: SxProps = isTruncated ? getTextTruncationSx(2) : {}; 
  const captionTruncationSx: SxProps = isTruncated ? getTextTruncationSx(1) : {};

  return (
    <Box
      sx={{
        gap: spaces.xs,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          alignSelf: 'start',
        }}
      >
        <Typography
          variant='overline'
          color='text.secondary'
          textTransform='uppercase'
        >
          {header}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexFlow: 'column', gap: spaces.xxs }}>
        <Link to={linkProps}>
          <Typography
            data-testid='mui-card-mobile__title'
            variant='h6'
            sx={{
              color: palette.text.primary,
              ...titleTruncationSx,
            }}
          >
            {title}
          </Typography>
        </Link>
        <Typography variant='caption' color='secondary' sx={captionTruncationSx}>
          {caption}
        </Typography>
      </Box>
    </Box>
  );
};

export default MuiCardBaseShortHeaderWithTitle;
